export const featureRegistrations = {};
export const lastActionsDefinitionRef = { current: {}, resolved: {}, raw: {} };
